import React from 'react'
import { Outlet } from 'react-router-dom'

const AccountLayout = () => {

    return (
        <div>
            <Outlet />
        </div>
    )
}

export default AccountLayout